var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "px-4 py-6 overflow-auto",
    staticStyle: {
      "background": "#FFF"
    }
  }, [_vm.userDetails.tipaltiDetails.paymentHistoryLink ? _c('iframe', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "src": _vm.userDetails.tipaltiDetails.paymentHistoryLink,
      "height": "800",
      "width": "1000"
    }
  }) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }